import { z } from "zod";

export const AddressSchema = z
  .object({
    type: z
      .enum([
        "apartment",
        "house",
        "townhome",
        "duplex",
        "mobile_home",
        "condo",
        "dorm",
        "business",
        "po box",
        "commercial",
        "warehouse",
        "office",
        "other",
        "venue",
        "theatre",
        "fairgrounds",
        "arena",
      ])
      .optional(),
    street: z.string().optional(),
    city: z.string().optional(),
    state: z.string().max(2).min(2),
    zip: z.string().regex(/^\d{5}/, "Zip must be #####"),
    country: z.string().optional(),
  })
  .describe("US address.");

export const AddressesSchema = z
  .object({
    $schema: z.string().optional(),
    primary: AddressSchema,
  })
  .catchall(AddressSchema)
  .describe("Collection of U.S addresses.");
